// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__N9t-8","title":"Header_title__25rvZ","side":"Header_side__dXmrA"};